import React from 'react'
import PropTypes from'prop-types'

import './PositionHeader.css'

const PositionHeader = ({
  filled,
  incumbent,
  position,
  runButtonVisible,
}) => (
  <header className="align-items-center PositionHeader">
    <div className="d-flex flex-column justify-content-center" style={{ flex: 1 }}>
      <h3>{position.name}</h3>
      <span className="PositionHeader__level">{position.level}</span>
    </div>
    {filled || incumbent ? (
      <span className="py-2 px-4 Position__Filed">
        {incumbent ? 'Incumbent' : 'Filed'}
      </span>
    ) : (
      runButtonVisible && <button
        className="btn btn-lg btn-primary align-self-center PositionHeader__btn"
        data-toggle="modal"
        data-target="#wantsToRunModal"
        type="button"
      >
        I Want to Run
      </button>
    )}
  </header>
)

PositionHeader.propTypes = {
  filled: PropTypes.bool.isRequired,
  position: PropTypes.object.isRequired,
  runButtonVisible: PropTypes.bool.isRequired,
}

PositionHeader.defaultProps = {
  filled: false,
  runButtonVisible: true,
}

export default PositionHeader



// WEBPACK FOOTER //
// ./src/components/Position/PositionHeader/PositionHeader.js